import introSec from "../../../../assets/mobile-security.jpeg";
import classrom from "../../../../assets/classrom.jpeg";
import global from "../../../../assets/global.jpeg";
import cyberDiff from "../../../../assets/mobile-security.jpeg";
import CybersecurityProgram from "../../Shared/CybersecurityPrograms";

const WirelessMobileSecurity = () => {
  return (
    <CybersecurityProgram
      backLink="/course/cyber-security"
      heroTitle="Wireless & Mobile Security"
      heroSubtitle="Securing the always-connected world of wireless networks and mobile devices."
      heroImage={introSec}
      introParagraphs={[
        "Wireless & Mobile Security addresses the unique challenges of securing communication channels and devices in today’s mobile-first world. From Wi-Fi networks to smartphones and IoT devices, attackers often exploit vulnerabilities in wireless protocols and mobile platforms.",
        "At JR Institute of Information Technology (JRIIT) in Tanzania, students gain the knowledge and practical skills to protect wireless networks, secure mobile applications, and defend against threats targeting portable technologies.",
      ]}
      classroom={{
        image: classrom,
        title: "IN THE CLASSROOM",
        paragraphs: [
          "In the classroom, students explore wireless security protocols such as WPA3, common Wi-Fi attacks like man-in-the-middle, packet sniffing, and rogue access points. They also study mobile OS security models for Android and iOS, mobile app vulnerabilities, and mobile device management (MDM) solutions.",
          "Hands-on labs include setting up secure Wi-Fi networks, testing mobile applications for vulnerabilities, simulating attacks such as Wi-Fi cracking and SMS phishing, and applying encryption for mobile communications.",
        ],
      }}
      beyondClassroom={{
        image: global,
        title: "BEYOND THE CLASSROOM",
        paragraphs: [
          "Beyond the classroom, learners engage in wireless security audits, mobile penetration testing exercises, and case studies involving real-world mobile data breaches and IoT attacks.",
          "Graduates of this module are prepared for careers as wireless security specialists, mobile application security analysts, penetration testers, and IoT security consultants, helping organizations defend against ever-evolving mobile threats.",
        ],
      }}
      difference={{
        image: cyberDiff,
        title: "WIRELESS & MOBILE SECURITY + THE JRIIT DIFFERENCE",
        paragraphs: [
          "What makes JRIIT’s Wireless & Mobile Security training unique is the balance of classroom theory and hands-on field practice. Students simulate real wireless and mobile attack scenarios while applying professional-grade defensive measures.",
          "This practical approach ensures graduates leave with the skills and confidence to secure mobile ecosystems and wireless infrastructures in today’s hyperconnected world.",
        ],
      }}
    />
  );
};

export default WirelessMobileSecurity;
